module.exports = __webpack_public_path__ + "img/agregar_usuario.784b35d3.svg";